import React from 'react';
import { BarChart3, PieChart as PieChartIcon, TrendingUp } from 'lucide-react';
import BarChartComponent from '../../Dashboard/charts/vis_barchart';
import PieChartComponent from '../../Dashboard/charts/vis_piechart';
import TrendChartComponent from '../../Dashboard/charts/vis_trendchart';

const ChartSection = ({ section, className = '', ...props }) => {
  const { config, data } = section;

  if (!data || data.length === 0) {
    return (
      <div className={`p-6 ${className}`} {...props}>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
          {config.title}
        </h3>
        <div className="flex flex-col items-center justify-center py-8 text-gray-500 dark:text-gray-400">
          <BarChart3 className="w-12 h-12 mb-2" />
          <p>No data available</p>
        </div>
      </div>
    );
  }

  const renderChart = () => {
    const chartProps = {
      data,
      title: config.title,
      loading: false,
      color: config.color || '#3b82f6',
      height: 400
    };

    switch (config.chartType) {
      case 'pie':
        return (
          <PieChartComponent
            {...chartProps}
            dataKey="value"
            nameKey="name"
          />
        );
      
      case 'line':
        return (
          <TrendChartComponent
            {...chartProps}
            dataKey="value"
            chartType="line"
          />
        );
      
      case 'bar':
      default:
        return (
          <BarChartComponent
            {...chartProps}
            xKey="name"
            yKey="value"
            layout="vertical"
          />
        );
    }
  };

  return (
    <div className={`p-6 ${className}`} {...props}>
      {renderChart()}
    </div>
  );
};

export default ChartSection;

